import { render } from "./xMain.vue?vue&type=template&id=3804c81d"
import script from "./xMain.vue?vue&type=script&lang=js"
export * from "./xMain.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__